<template>
  <div class="px-4 py-2 cursor-pointer hover:bg-gray-100">
    <slot />
  </div>
</template>

<script>
export default {}
</script>
